import { useEffect, useState } from "react"
import { RiFilePdf2Line } from "react-icons/ri";
import { Report } from "../../interfaces/intakes.reports"
import { PDFImages } from "../ui/ModalSendPDF"
import { ImagesPDF } from "../ui/ImagesPDF"
import { photosSavePDF } from "../../helpers/photosToShow"

interface Props {
  report: Report
  finalReport: Report
  setFinalReport: (report: Report) => void
  handlePreview: () => void
}

export const PDF_STEPS_IMAGES = ({ report, finalReport, setFinalReport, handlePreview }: Props) => {

  const [images, setImages] = useState<PDFImages[]>([])

  useEffect(() => {
    let allImages: PDFImages[] = []
    let defectImages = []
    for (const paly of finalReport.pallets) {
      allImages.push({
        pid: paly.pid,
        images: paly.images.map(imOne => (
          {
            imgURL: imOne.imgURL,
            imgURL_low: imOne.imgURL_low,
            key: imOne.key,
            key_low: imOne.key_low
          }
        ))
      })
    }
    for (const pall of finalReport.pallets) {
      defectImages.push({
        pid: pall.pid,
        images: photosSavePDF(pall)
      })
    }
    setImages(allImages)
  }, [finalReport])


  const handleSelectImage = (selectedImages: PDFImages[], pid?: string) => {
    setImages(images)

    const foundImages = selectedImages.find(img => img.pid === pid);

    if (foundImages) {
      const updatedPallets = finalReport.pallets.map(pallet => {
        if (pallet.pid === pid) {
          return {
            ...pallet,
            images: foundImages.images
          };
        }
        return pallet;
      });

      setFinalReport({
        ...finalReport,
        pallets: updatedPallets
      });
    }
  };


  return (
    <>
      <div className="tw-flex tw-justify-between tw-mb-4">

        <h4>Select the images</h4>

        <button onClick={handlePreview} className="tw-bg-red-500 tw-text-white tw-shadow tw-text-xs tw-flex tw-gap-2 tw-items-center tw-justify-center tw-px-2 tw-py-1 tw-rounded-full">
          <RiFilePdf2Line />
          Preview
        </button>
      </div>

      {
        report.pallets.map((pallet, i) => (
          <div key={pallet.pid}>
            <p className="mb-02 font-normal color-primary bold">Pallet {i + 1}</p>
            {
              pallet.images.length > 0
                ?
                <div className="modal-images mb-2 mt-05">
                  {
                    pallet.images.map(img => (
                      <ImagesPDF
                        key={img.key}
                        pid={pallet.pid}
                        images={images}
                        handleSelectImage={handleSelectImage}
                        img={img}
                      />
                    ))
                  }
                </div>
                : <p className='font-small mb-2'>No Images</p>
            }
          </div>
        ))
      }
    </>
  )
}
